import React from "react";
import "./styles/CarApp.css";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import FullscreenToggle from "./FullscreenToggle";
interface CarrierApp {
  GameStyle: 'animal' | 'family';
}

const AppContent: React.FC<CarrierApp> = ({ GameStyle }) => {
  return (
    <div id="car-content">
      <div className="car-conteiner">
        <div className="car-Logo-name">
          <a className="car-logo" href="https://kotobot.app/index.html">
            <img className="car-logo" title="На главную" src="/img/kotobot.svg" alt="Kotobot logo" />
          </a>
          <img className="car-mainsubtitle" src='/img/carrier/title.svg' alt="title name"/>
          <FullscreenToggle/>
        </div>
        <TopBar GameStyle={GameStyle} />
        <Board GameStyle={GameStyle} />
        <Helppanel GameStyle={GameStyle} />
      </div>
    </div>
  );
};

const App: React.FC<CarrierApp> = (props) => {
  return (
    <GameProvider>
      <AppContent GameStyle={props.GameStyle} />
    </GameProvider>
  );
};

export default App;